export default __webpack_public_path__ + "static/media/fbicon.b151965d.svg";